<template>
  <div v-if="clientAuthenticated === false">
    <client-authentication></client-authentication>
  </div>
  <div v-else-if="clientAuthenticated === true && userAuthenticated === false">
    <user-authentication></user-authentication>
  </div>
  <div v-else-if="clientAuthenticated === true && userAuthenticated === true">
    <router-view></router-view>
  </div>
  <div v-else>

  </div>
</template>

<script>
import ClientAuthentication from '@/components/ClientAuthentication'
import UserAuthentication from '@/components/UserAuthentication'

export default {
  name: 'app',
  components: {
    ClientAuthentication,
    UserAuthentication
  },
  computed: {
    userAuthenticated: function () {
      return this.$store.state.userAuthenticated
    },
    clientAuthenticated: function () {
      return this.$store.state.clientAuthenticated
    }
  },
  created () {
    this.$store.dispatch('refreshClientAuthentication').then(() => {
      this.$store.dispatch('refreshAuthentication').then(() => {}, () => {})
    }, () => {})
  }
}
</script>

<style>
    @import url("https://fonts.googleapis.com/css?family=Roboto+Slab");
</style>



// WEBPACK FOOTER //
// src/App.vue